import React from 'react'

import styles from './RecentSearchList.module.css'

interface Props {
  recentSearches: Array<string>
  setSearchText: (text: string) => void
}

export const RecentSearchList: React.FC<Props> = ({
  recentSearches,
  setSearchText,
}) => {
  return recentSearches && recentSearches.length > 0 ? (
    <div className={styles.recentSearches}>
      <div className={styles.recentSearchesHeader}>Recent searches</div>
      <div className={styles.recentSearchesMenu}>
        {recentSearches.map((eachSearch: string, key: number) => (
          <button
            className={styles.eachRecentSearchesMenu}
            key={key}
            onClick={() => setSearchText(eachSearch)}
          >
            {eachSearch}
          </button>
        ))}
      </div>
    </div>
  ) : null
}
